/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store/useAuth";
import { ComponentType, useEffect } from "react";

// Define a higher-order component function
export const withAdminPermission = (WrappedComponent: ComponentType<any>) => {
  // This function returns a new component
  return function WithAdminPermission(props: JSX.IntrinsicAttributes) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const isAdmin = [1, 5, 7].includes(user?.user_role ?? -1);

    useEffect(() => {
      if (!isAdmin) {
        navigate(-1);
      }
    }, [isAdmin]);

    if (!isAdmin) return null;
    return <WrappedComponent {...props} />;
  };
};
